import styled from 'styled-components';
import { rhythm } from 'Themes/typography';

const Heading = styled.h3`
  text-align: center;
  margin-bottom: ${rhythm(2)};
`;

export default Heading;
